const SIZE_SM_MIN = 320;
const SIZE_LG_MIN = 1024;
const SIZE_XL_MIN = 1440;
const SIZE_FULL_HD = 1920;

const SIZE_TABLET_XL_MIN = 1024;
const SIZE_TABLET_LG_MIN = 960;
const SIZE_TABLET_SM_MIN = 768;

const SIZE_PHONE_XL = 450;
const SIZE_PHONE_LG = 375;
const SIZE_PHONE_SM = 360;

const MAX_WIDTH_CONTENT = 1360;

const MIN_HEIGHT_720 = 720;
const MIN_HEIGHT_800 = 800;
const MIN_HEIGHT_960 = 960;

const SIZE_SM_MAX = SIZE_LG_MIN - 1;
const SIZE_LG_MAX = SIZE_XL_MIN - 1;

const SM_MIN = '(min-width: 0)';
const SM_MAX = `(max-width: ${SIZE_SM_MAX}px)`;
const SM_MAX_CUSTON = `(max-width: ${SIZE_SM_MIN}px)`;
const SM = `${SM_MIN} and ${SM_MAX}`;

const LG_MIN = `(min-width: ${SIZE_LG_MIN}px)`;
const LG_MAX = `(max-width: ${SIZE_LG_MAX}px)`;
const LG = `${LG_MIN} and ${LG_MAX}`;

const XL_MIN = `(min-width: ${SIZE_XL_MIN}px)`;
const XL = XL_MIN;

const SCREEN_TABLET_XL = `(max-width: ${SIZE_TABLET_XL_MIN}px)`;
const SCREEN_TABLET_LG = `(max-width: ${SIZE_TABLET_LG_MIN}px)`;
const SCREEN_TABLET_SM = `(max-width: ${SIZE_TABLET_SM_MIN}px)`;
const SCREEN_PHONE_XL = `(max-width: ${SIZE_PHONE_XL}px)`;
const SCREEN_PHONE_LG = `(max-width: ${SIZE_PHONE_LG}px)`;

const SCREEN_MIN_HEIGHT_720 = `(min-height: ${MIN_HEIGHT_720}px)`;
const SCREEN_MIN_HEIGHT_800 = `(min-height: ${MIN_HEIGHT_800}px)`;
const SCREEN_MIN_HEIGHT_960 = `(min-height: ${MIN_HEIGHT_960}px)`;

const SCREEN_MOBILE_CUSTOM = SM_MAX_CUSTON;
const SCREEN_MOBILE = SM_MAX;
const SCREEN_DESKTOP = LG_MIN;
const SCREEN_XL = XL_MIN;

export const adaptive = {
    LG,
    LG_MAX,
    LG_MIN,
    MAX_WIDTH_CONTENT,
    SCREEN_DESKTOP,
    SCREEN_MIN_HEIGHT_720,
    SCREEN_MIN_HEIGHT_800,
    SCREEN_MIN_HEIGHT_960,
    SCREEN_MOBILE,
    SCREEN_MOBILE_CUSTOM,
    SCREEN_PHONE_LG,
    SCREEN_PHONE_XL,
    SCREEN_TABLET_LG,
    SCREEN_TABLET_SM,
    SCREEN_TABLET_XL,
    SCREEN_XL,
    SIZE_FULL_HD,
    SIZE_LG_MAX,
    SIZE_LG_MIN,
    SIZE_PHONE_LG,
    SIZE_PHONE_SM,
    SIZE_PHONE_XL,
    SIZE_SM_MAX,
    SIZE_SM_MIN,
    SIZE_TABLET_LG_MIN,
    SIZE_TABLET_SM_MIN,
    SIZE_TABLET_XL_MIN,
    SIZE_XL_MIN,
    SM,
    SM_MAX,
    SM_MIN,
    XL,
    XL_MIN,
};
